import { gql } from "@apollo/client";

const GET_LANGUAGE_CATEGORIES = gql`
  query LanguageCategory {
    languagesCategory {
      id
      name
      order
      languages {
        id
        englishName
      }
    }
  }
`;

export default GET_LANGUAGE_CATEGORIES;
